import 'styles/countryFlags.css'
import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Referral from 'views/referral/Referral'
import ReferralCompanyData from 'views/referralCompany/ReferralCompanyData'
import ReferralPersonalData from 'views/referralPersonalData/ReferralPersonalData'
import ReferredImprovePlan from 'views/referredImprovePlan/ReferredImprovePlan'
import SubscriberData from 'views/subscriberData/SubscriberData'
import NewClient from 'views/nuevo-cliente/NewClient'

export const Navigation = () => (
  <Router basename=''>
    <Routes>
      <Route element={<Referral />}>
        <Route path='' element={<ReferralCompanyData />} />
        <Route path='referir-empresa' element={<ReferralCompanyData />} />
        <Route path='suscriptor' element={<SubscriberData />} />
        <Route path='datos' element={<ReferralPersonalData />} />
        <Route path='referido' element={<ReferredImprovePlan />} />
        <Route path='nuevo-cliente' element={<NewClient/>} />
      </Route>
      <Route path="*" element={<>Not found</>} />
    </Routes>
  </Router>
)
